module.exports = __webpack_public_path__ + "static/media/cashflow_placeholder_en.149ec51b.png";